import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { adminFetch } from '../../utils/auth';
import { getBackendUrl } from '../../utils/api';

interface ImagePreviewProps {
  imageId: string;
  size?: number;
  onClick?: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ imageId, size = 40, onClick }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoke = '';
    const load = async () => {
      try {
        const res = await adminFetch(`${getBackendUrl()}/api/upload/admin/preview/${imageId}`);
        if (!res.ok) { setError(true); return; }
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        revoke = url;
        setSrc(url);
      } catch {
        setError(true);
      }
    };
    load();
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [imageId]);

  if (error || !imageId) {
    return (
      <div
        onClick={onClick}
        style={{
          width: size, height: size, borderRadius: 6, background: '#f5f5f5',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '1px solid #e8e8e8', cursor: onClick ? 'pointer' : 'default', flexShrink: 0,
        }}
      >
        <CameraOutlined style={{ fontSize: size * 0.4, color: '#bfbfbf' }} />
      </div>
    );
  }

  if (!src) {
    return (
      <div style={{ width: size, height: size, borderRadius: 6, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e8e8e8', flexShrink: 0 }}>
        <Spin size="small" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="Uploaded part"
      onClick={onClick}
      style={{
        width: size, height: size, borderRadius: 6, objectFit: 'cover',
        border: '1px solid #e8e8e8', cursor: onClick ? 'pointer' : 'default', flexShrink: 0,
      }}
    />
  );
};

export default ImagePreview;
